import { mayTryStudentLogin } from "../../../packages/api/transport";
import { useEffect, useState } from "react";
import { ArrowRight, Layers } from "lucide-react";
import {
  ApiError,
  DEMO,
  rawRequest,
  tenantSlug,
  useSession,
  type Row,
} from "../../../packages/api/client";
import { ErrorNotice } from "../../../packages/ui";
import { FlowLoginButton } from "./FlowLogin";

export function Login() {
  const { login } = useSession();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [branding, setBranding] = useState<Row | null>(null);
  const [brandingError, setBrandingError] = useState("");
  const slug = tenantSlug(location.hostname);
  useEffect(() => {
    if (!slug) return;
    const controller = new AbortController();
    rawRequest<Row>(
      `/public/tenant-branding?slug=${encodeURIComponent(slug)}`,
      "",
      { signal: controller.signal },
    )
      .then(setBranding)
      .catch((e) => {
        if (!controller.signal.aborted) setBrandingError(e.message);
      });
    return () => controller.abort();
  }, [slug]);
  return (
    <main className="login-page">
      <div className="login-wordmark">
        <Layers size={23} />
        汇聚
      </div>
      <section className="login-card">
        <span className="login-symbol">
          <Layers size={28} />
        </span>
        <h1>{branding?.schoolName || "登录汇聚"}</h1>
        <FlowLoginButton />
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (busy || brandingError) return;
            setBusy(true);
            setError("");
            const form = new FormData(e.currentTarget);
            const body = JSON.stringify({
              username: form.get("username"),
              password: form.get("password"),
              ...(slug ? { tenantSlug: slug } : {}),
            });
            try {
              const result = await rawRequest<{ token: string }>(
                "/auth/teacher/login",
                "",
                { method: "POST", body },
              );
              login(result.token);
            } catch (e) {
              if (mayTryStudentLogin(e)) {
                try {
                  const result = await rawRequest<{ token: string }>(
                    "/auth/login",
                    "",
                    { method: "POST", body },
                  );
                  sessionStorage.setItem(
                    "teaching-flow-student-token",
                    result.token,
                  );
                  location.assign("/student/");
                } catch (e) {
                  setError(e instanceof Error ? e.message : "登录失败");
                }
              } else setError(e instanceof Error ? e.message : "登录失败");
            } finally {
              setBusy(false);
            }
          }}
        >
          <ErrorNotice error={brandingError || error} />
          <label>
            账号
            <input
              name="username"
              autoComplete="username"
              required
              autoFocus
              placeholder="输入账号"
            />
          </label>
          <label>
            密码
            <input
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="输入密码"
            />
          </label>
          <button className="button primary" disabled={busy || !!brandingError}>
            {busy ? "登录中…" : "登录"}
            <ArrowRight size={16} />
          </button>
        </form>
        {DEMO && (
          <>
            <button
              className="button demo-entry"
              onClick={() => login("react-preview-teacher")}
            >
              进入演示环境
            </button>
            <button
              className="button demo-entry"
              onClick={() => login("react-preview-admin")}
            >
              管理员演示
            </button>
          </>
        )}
      </section>
      <footer>汇聚教育</footer>
    </main>
  );
}
